/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React, {useEffect, useState} from 'react';
import ProfileView from "../../views/profile/ProfileView";
import {useAuth} from "../../data/userContext";
import {patchTo, postTo} from "../../data/api";
import {CHECK_EMAIL, CHECK_PASSWORD} from "../../data/formats";

function ProfileRoute(props) {
    const [changingEmail, setChangingEmail] = useState({oldEmail: "", newEmail: "", newEmailAgain: ""})
    const [changingPassword, setChangingPassword] = useState({oldPassword: "", password: "", passwordAgain: ""})
    const [submittingEmail, setSubmittingEmail] = useState(false)
    const [emailSubmitInfo, setEmailSubmitInfo] = useState({status: "", text: ""})
    const [passwordSubmitInfo, setPasswordSubmitInfo] = useState({status: "", text: ""})
    const [submittingPassword, setSubmittingPassword] = useState(false)
    const [errorEmail, setErrorEmail] = useState({old: false, new: false, newAgain: false})
    const [errorPassword, setErrorPassword] = useState({old: false, new: false, newAgain: false})


    const auth = useAuth()

    const change = (which, data) => {
        switch (which){
            case 'oldEmail': setChangingEmail({...changingEmail, oldEmail: data}); break;
            case 'newEmail': setChangingEmail({...changingEmail, newEmail: data}); break;
            case 'newEmailAgain': setChangingEmail({...changingEmail, newEmailAgain: data}); break;
            case 'oldPassword': setChangingPassword({...changingPassword, oldPassword: data}); break;
            case 'password': setChangingPassword({...changingPassword, password: data}); break;
            case 'passwordAgain': setChangingPassword({...changingPassword, passwordAgain: data}); break;
            default: break;
        }
    }

    const submitChangeEmail = () => {
        setSubmittingEmail(true)
        if(auth.user.email !== changingEmail.oldEmail){
            console.error("Bad email")
            setSubmittingEmail(false)
            return;
        }
        if(changingEmail.newEmail !== changingEmail.newEmailAgain){
            console.error("not the same")
            setSubmittingEmail(false)
            return
        }

        postTo('/users/change-email', changingEmail).then((res) => {
            //Email changed 
            auth.setAuth(res.data)
            setSubmittingEmail(false)
            setChangingEmail({...changingEmail, oldEmail: "", newEmail: "", newEmailAgain: ""})
            setEmailSubmitInfo({status: "success", text: "Email zmenený!"})
        }).catch((e)=>{
            console.error(e)
            setSubmittingEmail(false)
            setEmailSubmitInfo({status: "error", text: "Email sa nezmenil!"})
        })
    }

    const submitChangePassword = () => {
        setSubmittingPassword(true)
        if(changingPassword.password !== changingPassword.passwordAgain){
            console.error("not the same")
            setSubmittingPassword(false)
            return
        }

        postTo('/users/change-password', changingPassword).then((res) => {
            //Password changed
            setSubmittingPassword(false)
            setChangingPassword({...changingPassword, oldPassword: "", password: "", passwordAgain: ""})
            setPasswordSubmitInfo({status: "success", text: "Heslo zmenené!"})
        }).catch((e)=>{
            console.error(e)
            setSubmittingPassword(false)
            setPasswordSubmitInfo({status: "error", text: "Heslo sa nezmenilo!"})
        })
    }
    useEffect(()=>{
        const newErrors = {...errorEmail}
        newErrors.old = changingEmail.oldEmail !== "" && !CHECK_EMAIL.test(changingEmail.oldEmail);
        newErrors.new = changingEmail.newEmail !== "" && !CHECK_EMAIL.test(changingEmail.newEmail);
        newErrors.newAgain = changingEmail.newEmailAgain !== "" && changingEmail.newEmail !== changingEmail.newEmailAgain;
        setErrorEmail({...newErrors})
    },[changingEmail])
    useEffect(()=>{
        const newErrors = {...errorPassword}
        newErrors.old = changingPassword.oldPassword !== "" && !CHECK_PASSWORD.test(changingPassword.oldPassword);
        newErrors.new = changingPassword.password !== "" && !CHECK_PASSWORD.test(changingPassword.password);
        newErrors.newAgain = changingPassword.passwordAgain !== "" && changingPassword.password !== changingPassword.passwordAgain;
        setErrorPassword({...newErrors})
    },[changingPassword])

    return (
        <ProfileView user={auth.user}
                     changeEmailOld={(e)=>{change('oldEmail', e.target.value)}}
                     changeEmailNew={(e)=>{change('newEmail', e.target.value)}}
                     changeEmailNewAgain={(e)=>{change('newEmailAgain', e.target.value)}}
                     submitChangeEmail={submitChangeEmail}
                     submittingEmail={submittingEmail}
                     changePasswordOld={(e)=>{change('oldPassword', e.target.value)}}
                     changePasswordNew={(e)=>{change('password', e.target.value)}}
                     changePasswordNewAgain={(e)=>{change('passwordAgain', e.target.value)}}
                     submitChangePassword={submitChangePassword}
                     submittingPassword={submittingPassword}
                     emailErrors={errorEmail}
                     passwordErrors={errorPassword}
                     emailValues={changingEmail}
                     passwordValues={changingPassword}
                     passwordSubmitInfo={passwordSubmitInfo}
                     emailSubmitInfo={emailSubmitInfo}
        />
    );
}

export default ProfileRoute;